const TIPO_RECEITA = 1
const TIPO_DESPESA = 2

const DESCRICAO_TIPOS = {
  [TIPO_RECEITA]: 'Receita',
  [TIPO_DESPESA]: 'Despesa',
}

const TIPO_MOVIMENTO_VALOR_TOTAL = 1
const TIPO_MOVIMENTO_VALOR_LIQUIDO = 2

const DESCRICAO_TIPO_MOVIMENTO = {
  [TIPO_MOVIMENTO_VALOR_TOTAL]: 'Valor Total',
  [TIPO_MOVIMENTO_VALOR_LIQUIDO]: 'Valor Líquido',
}

const PAYMENT_SITUATION_LABELS = { open: 'Em aberto', overdue: 'Vencido', paid: 'Pago' }
const PAYMENT_SITUATION_COLORS = { open: 'warning', overdue: 'error', paid: 'success' }
const PAYMENT_SITUATION_OPTIONS = ['open', 'overdue', 'paid'].map(value => ({
  value, text: PAYMENT_SITUATION_LABELS[value],
}))

export {
  PAYMENT_SITUATION_LABELS,
  PAYMENT_SITUATION_COLORS,
  PAYMENT_SITUATION_OPTIONS,
  TIPO_RECEITA,
  TIPO_DESPESA,
  DESCRICAO_TIPOS,

  TIPO_MOVIMENTO_VALOR_TOTAL,
  TIPO_MOVIMENTO_VALOR_LIQUIDO,
  DESCRICAO_TIPO_MOVIMENTO,
}
